jQuery(function ($) {
  function initFormValidation($form) {
    if (!$form.length || $form.data('validator-initialized')) return;

    $.validator.methods.email = function (value, element) {
      return this.optional(element) ||
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
    };

    $.extend($.validator.messages, {
      required: jsvar.required,
      email: jsvar.email_invalid
    });

    $form.validate({
      errorClass: 'form--error',
      errorElement: 'div',

      rules: {
        email: {
          required: true,
          email: true
        },
        phone: {
          required: true
        },
        message: {
          required: true
        }
      },

      messages: {
        email: {
          required: jsvar.email_required,
          email: jsvar.email_invalid
        },
        phone: {
          required: jsvar.phone_required
        },
        message: {
          required: jsvar.message_required
        }
      },

      submitHandler: function (formEl) {
        const $thisForm = $(formEl);
        const $submit = $thisForm.find('[type="submit"]');

        $thisForm.find('.form-error').remove();
        $submit.prop('disabled', true).addClass('active');

        $.ajax({
          type: 'POST',
          url: jsvar.ajax_url,
          data: $thisForm.serialize(),
          dataType: 'json',
          success: function (response) {
            if (response.success) {
              $thisForm.replaceWith(
                `<div class="form-success">${response.data.message}</div>`
              );
              return;
            }

            $thisForm.prepend(
              `<div class="form-error">${response.data?.message || jsvar.form_error}</div>`
            );

            $submit.prop('disabled', false).removeClass('active');
          },
          error: function (xhr) {
            const message = xhr.responseJSON?.data?.message || jsvar.form_error;

            $thisForm.prepend(`<div class="form-error">${message}</div>`);
            $submit.prop('disabled', false).removeClass('active');
          }
        });

        return false;
      }
    });

    $form.data('validator-initialized', true);
  }

  initFormValidation($('.modal[data-id="contact-form"] form.form'));

  $(document).on(
    'focus',
    '.modal[data-id="contact-form"] form.form input, .modal[data-id="contact-form"] form.form textarea',
    function () {
      initFormValidation($('.modal[data-id="contact-form"] form.form'));
    }
  );
});
